<button (click)="click()" [class]="buttonClass()" [disabled]="resolvedProps().isDisabled">
  {{ resolvedProps().text }} @if (resolvedProps().isLoading) {
  <span class="fnf-button-loader animate-spin"></span>
  }
</button>
